var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenewableEnergyCredit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5873 6.96436V2.26245H2.85162V19.0229H12.7706V22.2625L16.4422 20.0397L20.1205 22.2625V15.3018C20.724 14.6571 21.1472 13.8648 21.3474 13.0046C21.5477 12.1444 21.5179 11.2467 21.2612 10.4017C21.0045 9.55664 20.5298 8.7941 19.8848 8.19071C19.2399 7.58733 18.4475 7.16437 17.5873 6.96436ZM12.7706 15.3018V17.2253H4.65139V4.06223H15.7875V6.87662C14.8705 6.99715 14.0045 7.36817 13.2846 7.94888C12.5648 8.52959 12.0189 9.29753 11.7071 10.1683C11.3953 11.039 11.3296 11.9789 11.5173 12.8845C11.7049 13.7902 12.1386 14.6266 12.7706 15.3018ZM18.3252 19.0701L16.4467 17.9452L14.5682 19.0701V16.5369C15.7726 17.0229 17.1185 17.0229 18.3229 16.5369L18.3252 19.0701ZM16.4422 15.1038C15.8026 15.1025 15.1778 14.9116 14.6467 14.5554C14.1156 14.1991 13.702 13.6934 13.4581 13.1021C13.2143 12.5108 13.1512 11.8606 13.2768 11.2335C13.4024 10.6064 13.711 10.0306 14.1637 9.57882C14.6164 9.12706 15.1929 8.81961 15.8203 8.69533C16.4476 8.57105 17.0977 8.63551 17.6885 8.88056C18.2792 9.12562 18.7841 9.54027 19.1393 10.0721C19.4944 10.604 19.684 11.2292 19.684 11.8688C19.6828 12.7276 19.3407 13.5507 18.7328 14.1574C18.1249 14.764 17.301 15.1044 16.4422 15.1038Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0305 5.91821H5.7875V7.71799H12.0305V5.91821Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0057 9.7428H5.7875V11.5426H10.0057V9.7428Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9056 13.5673H5.7875V15.367H10.9056V13.5673Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewableEnergyCredit);
export default __webpack_public_path__ + "static/media/renewable-energy-credit.011fc7ab.svg";
export { ForwardRef as ReactComponent };